import { AxiosResponse } from 'axios';
import {
  GetProjectDocumentByIdRequest,
  GetProjectsListRequest,
  CreateProjectRequest,
  UpdateProjectRequest,
  GetProjectsInsightsRequest,
  AddProjectUsersRequest,
  ProjectAccessRequestParams,
  UpdateProjectUserRequest,
  SendFeedbackRequest,
} from '../types/Dtos/request';
import {
  CreateNewProjectResponse,
  GetInsightsResponse,
  GetProjectDetailsResponse,
  GetProjectUsersResponse,
  GetProjectsListResponse,
} from '../types/Dtos/response';
import { getQueryParamsFromObj } from '../utils/api';
import { aiApi } from '../utils/aiApi';
import { getDocumentByOrganizationAndProject } from './documentsService';

const BASE = 'v1/projects';
const ACCESS_BASE = 'v1/project-access';

export const getProjectDocumentById = ({
  projectId,
  organizationId,
  documentId,
}: GetProjectDocumentByIdRequest) =>
  getDocumentByOrganizationAndProject(organizationId, projectId, documentId);

export const getProjectsList = ({ organizationId, ...payload }: GetProjectsListRequest) =>
  aiApi.get<GetProjectsListResponse>(
    `${BASE}?${getQueryParamsFromObj({ organizationId, ...payload })}`,
  );

export const createProject = ({
  organizationId,
  ...payload
}: CreateProjectRequest): Promise<AxiosResponse<CreateNewProjectResponse>> =>
  aiApi.post(`${BASE}?${getQueryParamsFromObj({ organizationId })}`, {
    ...payload,
    mode: +payload.mode,
  });

export const deleteProject = (projectId: string) => aiApi.delete(`${BASE}/${projectId}`);

export const getProjectDetails = (projectId: string) =>
  aiApi.get<GetProjectDetailsResponse>(`${BASE}/${projectId}`);

export const updateProject = ({ projectId, ...payload }: UpdateProjectRequest) =>
  aiApi.put<GetProjectDetailsResponse>(`${BASE}/${projectId}`, payload);

export const getProjectInsights = ({ projectId, ...payload }: GetProjectsInsightsRequest) =>
  aiApi.get<GetInsightsResponse>(
    `${BASE}/${projectId}/insights?${getQueryParamsFromObj({ ...payload })}`,
  );

export const getProjectUsers = ({ projectId, organizationId }: ProjectAccessRequestParams) =>
  aiApi.get<GetProjectUsersResponse>(
    `${ACCESS_BASE}/${organizationId}/projects/${projectId}/users`,
  );

export const assignProjectUsers = ({
  projectId,
  organizationId,
  assignedUsers,
}: AddProjectUsersRequest) =>
  aiApi.post(`${ACCESS_BASE}/${organizationId}/projects/${projectId}/users`, { assignedUsers });

export const removeProjectUser = ({ projectId, organizationId, data }: UpdateProjectUserRequest) =>
  aiApi.delete(`${ACCESS_BASE}/${organizationId}/projects/${projectId}/users`, { data });

export const updateProjectUserRole = ({
  projectId,
  organizationId,
  data,
}: UpdateProjectUserRequest) =>
  aiApi.put(`${ACCESS_BASE}/${organizationId}/projects/${projectId}/users`, { ...data });

export const getProjectAccessOrganizationUsers = (organizationId: string) =>
  aiApi.get<GetProjectUsersResponse>(`${ACCESS_BASE}/${organizationId}/users`);

export const sendFeedback = ({ projectId, payload }: SendFeedbackRequest) =>
  aiApi.put(`${BASE}/${projectId}/feedback`, { ...payload });

export const pinProject = (projectId: string) => aiApi.post(`${BASE}/${projectId}/pin`);

export const unpinProject = (projectId: string) => aiApi.delete(`${BASE}/${projectId}/pin`);

export const softArchiveProject = (projectId: string) =>
  aiApi.put(`${BASE}/${projectId}/soft-archive`);

export const unSoftArchiveProject = (projectId: string) =>
  aiApi.put(`${BASE}/${projectId}/un-soft-archive`);

export const setProjectRestricted = (projectId: string) =>
  aiApi.put(`${BASE}/${projectId}/restricted`);

export const setProjectOpen = (projectId: string) => aiApi.put(`${BASE}/${projectId}/open`);
